<!-- Preview Controls -->
@if (!showEmailInline && showDevicePreviewSizeButtons && showDevicePreviewSizeButtonsOnResize) {
  <div class="email-preview-controls">
    <glxy-button-group class="device-preview-size">
      @if (showDesktopButton) {
        <button mat-stroked-button (click)="emailPreviewWidth = maxWidthDesktop">
          <mat-icon>computer</mat-icon>
          Desktop
        </button>
      }
      <button mat-stroked-button (click)="emailPreviewWidth = maxWidthTablet">
        <mat-icon>tablet_mac</mat-icon>
        Tablet
      </button>
      <button mat-stroked-button (click)="emailPreviewWidth = maxWidthMobile">
        <mat-icon>phone_iphone</mat-icon>
        Mobile
      </button>
    </glxy-button-group>
  </div>
}

<!-- Email Preview and Sourcecode -->
@if (html) {
  <div class="preview-iframe-container">
    <iframe
      #iframePreview
      sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox"
      class="email-preview-iframe"
      [style.max-width]="emailPreviewWidth"
      [style.min-height]="showEmailInline ? '100vh' : null"
      [style.height]="showEmailInline ? iframeContentHeight : null"
      [srcdoc]="html | iTrustThisHtml"
      (load)="calculateIframeContentHeight()"
    ></iframe>
  </div>
} @else {
  <glxy-loading-spinner />
}
